import { render, staticRenderFns } from "./siteFooter.vue?vue&type=template&id=7c5ce012&scoped=true"
import script from "./siteFooter.vue?vue&type=script&lang=js"
export * from "./siteFooter.vue?vue&type=script&lang=js"
import style0 from "./siteFooter.vue?vue&type=style&index=0&id=7c5ce012&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c5ce012",
  null
  
)

export default component.exports